// extracted by mini-css-extract-plugin
export default {"header":"PalletBalancePage_header__kn+I7"};